<template>
  <div>
    <div class="content">
      <div class="info-card">
        <div style="display: flex;justify-content: center;align-items: center" class="info-content">
          <span class="user-info-content">程序名称：</span>
          <el-input v-model="programName" autocomplete="off"></el-input>
        </div>
      </div>

      <div class="info-card">
        <div style="display: flex;justify-content: center;align-items: center" class="info-content">
          <span class="user-info-content">程序描述：</span>
          <el-input v-model="description" autocomplete="off"></el-input>
        </div>
      </div>

      <div class="info-card">
        <div style="display: flex;justify-content: center;align-items: center" class="info-content">
          <span class="user-info-content">选择程序类型：</span>
          <el-select v-model="programType" placeholder="请选择程序类型">
            <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="button-group-card">
        <div class="button-group-title">
          <el-button type="success" @click="createProgram" :plain="true">确认创建</el-button>
        </div>
      </div>
    </div>
    <el-dialog title="确认创建程序？" :visible.sync="commitDialogVisible">
      <div slot="footer" class="dialog-footer">
        <el-button @click="commitDialogVisible=false">取 消</el-button>
        <el-button type="primary" @click="handleCommit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import API from "../../../../config/api";

export default {
  name: "CreateNewProgram",
  props: {companyId: Number},
  data() {
    return {
      programName: '',      // 程序名称
      description: '',  // 程序描述
      programType: '',  // 程序类型
      options: [        //选择框的选择内容
        {id:0,name:"梯形图"},
        {id:1,name:"C语言"},
        {id:2,name:"Python语言"},
      ],
      userId: '',     // 创建者
      productId: '',  //新建的脚本的Id
      commitDialogVisible: false, //提交脚本 对话框
    }
  },
  mounted() {
    this.userId = window.localStorage.getItem('userid');
  },
  methods: {
    handleCommit(){
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let newProgram = {
        companyId: this.companyId,
        programName: this.programName,
        description: this.description,
        programType: this.programType,
        userId: this.userId,
      }

      this.$axiosRequest({
        url: API.addPLC,
        method: 'POST',
        data: newProgram,
        header: header,
        success: res => {
          if (res.data > 0) {
            this.$message({
              message: '创建程序成功',
              type: 'success'
            });
            this.commitDialogVisible = false;
            let newChild = { //后期删掉
              label: this.programName,
              stageType: 7,
              id: res.data,
              updateVariableId: this.updateVariableId,
              uniqueId: 'PLC_' + res.data,
              children: []
            }
            this.$emit('add', newChild);
          } else if (res.data === 0) {
            this.$message({
              message: '程序名称已存在',
              type: 'error'
            });
          } else if (res.data === -2) {
            this.$message({
              message: '参数出错',
              type: 'error'
            });
          } else if (res.data === -1) {
            this.$message({
              message: '添加程序出错',
              type: 'error'
            });
          }
        }
      });
    },
    //确认创建脚本
    createProgram() {
      if (this.programType !== 1) {
        this.$message({
          message: "开发中",
          type: 'warning'
        });
        return
      }
      if (this.programName !== '' && this.description !== '' && this.programKind !== '') {
        this.commitDialogVisible = true;
      } else if(this.programName == ''){
        this.$message({
          message: "程序名称不能为空！",
          type: 'warning'
        });
      }else if(this.description == ''){
        this.$message({
          message: "程序描述不能为空！",
          type: 'warning'
        });
      }else if(this.programType == ''){
        this.$message({
          message: "程序类型不能为空！",
          type: 'warning'
        });
      }
    },
  }
}
</script>

<style scoped>

</style>